export const FAX_NUMBER_FORMAT = '($1) $2-$3';
